function SectionCandidateExperience() {
    return (
        <>
            <h4 className="twm-s-title">Work Experience</h4>
            <div className="twm-timing-list-wrap">
                <div className="twm-timing-list">
                    <div className="twm-time-list-date">2012 to 2016</div>
                    <div className="twm-time-list-title">Bluetech, Inc</div>
                    <div className="twm-time-list-position">Senior PHP Developer</div>
                    <div className="twm-time-list-discription">
                        <p>One of the main areas that I work on with my clients is shedding these non-supportive beliefs and
                            replacing them with beliefs that will help them to accomplish their desires.</p>
                    </div>
                </div>
                <div className="twm-timing-list">
                    <div className="twm-time-list-date">2016 to 2020</div>
                    <div className="twm-time-list-title">Amazon, Inc</div>
                    <div className="twm-time-list-position">IT &amp; Development</div>
                    <div className="twm-time-list-discription">
                        <p>One of the main areas that I work on with my clients is shedding these non-supportive beliefs and
                            replacing them with beliefs that will help them to accomplish their desires.</p>
                    </div>
                </div>
                <div className="twm-timing-list">
                    <div className="twm-time-list-date">2020 to 2023</div>
                    <div className="twm-time-list-title">BGoogle, Inc</div>
                    <div className="twm-time-list-position">Senior UI / UX Designer and Developer </div>
                    <div className="twm-time-list-discription">
                        <p>One of the main areas that I work on with my clients is shedding these non-supportive beliefs and
                            replacing them with beliefs that will help them to accomplish their desires.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionCandidateExperience;